export interface FilesPaginationState {
  pageSize: number;
  isLoading: boolean;
  nextPageToken?: string;
}

export const paginationDefaultState: FilesPaginationState = {
  pageSize: 25,
  isLoading: false,
  nextPageToken: undefined,
};

export function savePageForLoadedFiles(
  state: FilesPaginationState,
  payload: any,
): FilesPaginationState {
  return {
    ...state,
    nextPageToken: payload.nextPageToken,
    isLoading: false,
  };
}

export function setLoadingStarted(
  state: FilesPaginationState,
): FilesPaginationState {
  return {
    ...state,
    isLoading: true,
  };
}

export function setLoadingFailed(
  state: FilesPaginationState,
): FilesPaginationState {
  return {
    ...state,
    isLoading: false,
  };
}
